var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 8.25H11.25C11.0511 8.25 10.8603 8.32902 10.7197 8.46967C10.579 8.61032 10.5 8.80109 10.5 9V12C10.5018 13.0625 10.8792 14.0901 11.5654 14.9012C12.2516 15.7123 13.2025 16.2547 14.25 16.4325V21H12V22.5H18V21H15.75V16.4325C16.7975 16.2547 17.7484 15.7123 18.4346 14.9012C19.1208 14.0901 19.4982 13.0625 19.5 12V9C19.5 8.80109 19.421 8.61032 19.2803 8.46967C19.1397 8.32902 18.9489 8.25 18.75 8.25ZM18 12C18 12.7956 17.6839 13.5587 17.1213 14.1213C16.5587 14.6839 15.7956 15 15 15C14.2044 15 13.4413 14.6839 12.8787 14.1213C12.3161 13.5587 12 12.7956 12 12V9.75H18V12Z",
    fill: "#79AC78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2509 0.75H7.50087C7.30196 0.75 7.11119 0.829018 6.97054 0.96967C6.82989 1.11032 6.75087 1.30109 6.75087 1.5V7.0275C6.02208 7.45446 5.42596 8.07514 5.02875 8.82057C4.63154 9.56599 4.44881 10.407 4.50087 11.25V21.75C4.50087 21.9489 4.57989 22.1397 4.72054 22.2803C4.86119 22.421 5.05196 22.5 5.25087 22.5H9.00087V21H6.00087V11.25C6.00087 8.85975 7.67412 8.235 7.73787 8.21175L8.25087 8.04V2.25H10.5009V6H12.0009V1.5C12.0009 1.30109 11.9219 1.11032 11.7812 0.96967C11.6405 0.829018 11.4498 0.75 11.2509 0.75Z",
    fill: "#79AC78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.c3a282e2ce931e0d2b761046f5d94bdf.svg";
export { ForwardRef as ReactComponent };